/**
 * Created by olga on 02.08.2024
 */

Mission.TYPE_KINGSCUP = 74;

Mission.REGISTRATIONS.set(Mission.TYPE_KINGSCUP, () => ({
    available: cleverapps.config.availables.KINGS_CUP_MISSION,
    abTest: function () {
        if (cleverapps.config.name === "ladacha") {
            return cleverapps.abExperiments.getGroup(ABExperiments.Tests.ladachaLiveOps) === "A";
        }

        return true;
    },
    logic: KingsCupLogic,
    view: KingsCupStartWindow,
    schedule: "MON-FRI",
    prize: RewardsConfig.KingsCup,
    teaser: true,
    name: "KingsCup",
    semaphore: Mission.SEMAPHORE_ALWAYS,
    collectIcon: bundles.tournament_icon.frames.mission_kingscup_png,
    competition: {
        algo: PersonalBestBotAlgorithm,
        avgSpeed: "kingscup",
        amount: [20, 30],
        forceCoef: [90, 120],
        prizeIconsBundle: "kingscup_table"
    },
    sideBarPlace: cleverapps.config.type === "merge",
    sideBarJson: bundles.sidebar.jsons.kingscup_icon_json,
    rowView: cleverapps.config.type === "merge2" ? function (row) {
        return Prefab.instantiate(bundles.merge.jsons.kingscup_orders_row_prefab_json, { mission: row.data.mission });
    } : undefined,
    startWindow: KingsCupStartWindow,
    guideWindow: {
        name: "KingsCupRulesWindow",
        bundle: bundles.kingscupruleswindow,
        title: "KingsCupRulesWindow.title"
    },
    bundle: "kingscup_window"
}));
